import * as React from 'react'
const AttachmentIcon = ({ colorA = "#d7dae0" }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
      <path d="M4.83 10.49l5.65-5.66a3 3 0 014.25 4.24L8 15.79a1.51 1.51 0 01-2.12 0 1.49 1.49 0 010-2.12l6-6a.51.51 0 000-.71.5.5 0 00-.71 0l-6 6a2.5 2.5 0 003.55 3.54l6.71-6.72a4 4 0 10-5.65-5.66L4.12 9.78a.5.5 0 10.71.71z" className="-secondary-color" fill="#d7dae0"/>
    </svg>
    
  )
}

export default AttachmentIcon